import { z } from 'zod';

const ReverseProposalStatusSchema = z.enum(['WAITING', 'APPROVED', 'REJECTED']);
const ReverseProposalSortSchema = z.enum(['LATEST', 'BRAND_NAME']);

export const GetReverseProposalsServiceRequestSchema = z
  .object({
    status: ReverseProposalStatusSchema.optional(),
    sort: ReverseProposalSortSchema.optional(),
    page: z.number().min(1),
    size: z.number().min(1).max(100),
  })
  .describe('GetReverseProposalsServiceRequestSchema');

export type GetReverseProposalsServiceRequest = z.infer<
  typeof GetReverseProposalsServiceRequestSchema
>;

const ReverseProposalItemSchema = z
  .object({
    id: z.number(),
    status: ReverseProposalStatusSchema,
    brandImageUrl: z.string(),
    brandId: z.string(),
    brandName: z.string(),
    message: z.string(),
    createdAt: z.string(),
    startAt: z.string(),
    campaignProposalId: z.number().nullable().optional(),
  })
  .describe('ReverseProposalItemSchema');

export type ReverseProposalItem = z.infer<typeof ReverseProposalItemSchema>;

export const GetReverseProposalsServiceResponseSchema = z.object({
  list: z.array(ReverseProposalItemSchema),
  total: z.number(),
  pagination: z.object({
    currentPage: z.number(),
    pageSize: z.number(),
    hasNextPage: z.boolean(),
    nextPage: z.number().optional(),
  }),
});

export type GetReverseProposalsServiceResponse = z.infer<
  typeof GetReverseProposalsServiceResponseSchema
>;
